/**
 * @generated SignedSource<<b1523ebc48ff3cc6a6ef8ad8575890e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteBulkScheduleItemMutation$variables = {
  listId?: ReadonlyArray<string> | null | undefined;
};
export type DeleteBulkScheduleItemMutation$data = {
  readonly deleteBulkScheduleItem: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type DeleteBulkScheduleItemMutation = {
  response: DeleteBulkScheduleItemMutation$data;
  variables: DeleteBulkScheduleItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "listId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "listId",
        "variableName": "listId"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteBulkScheduleItem",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteBulkScheduleItemMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteBulkScheduleItemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1528f3f4ac2378a0f3006bd40297a682",
    "id": null,
    "metadata": {},
    "name": "DeleteBulkScheduleItemMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteBulkScheduleItemMutation(\n  $listId: [ID!]\n) {\n  deleteBulkScheduleItem(listId: $listId)\n}\n"
  }
};
})();

(node as any).hash = "42111bbfb513db85d3285700b434cbf9";

export default node;
